<template>
  <div class="form">
    <Form2ItemInput
      v-model="newIdentifier"
      ref="newIdentifier"
      label="新手机号码"
      :required="true"
      max="11"
      :rule="[
        { required: true, message: `新手机号码不能为空`, trigger: `blur` },
        { pattern: pattern.phone, message: `新手机号码不正确`, trigger: `blur`},
      ]"
    />
    <Form2ItemInput
      v-model="imageCaptcha"
      ref="imageCaptcha"
      label="图片验证码"
      type="imageCaptcha"
      :required="true"
      max="4"
      :rule="[
        { required: true, message: `图片验证码不能为空`, trigger: `blur` },
        { pattern: pattern.isLetterOrNumber(4), message: `图片验证码不正确`, trigger: `blur`}
      ]"
    />
    <Form2ItemInput
      v-model="smsCaptcha"
      ref="smsCaptcha"
      label="短信验证码"
      type="smsCaptcha"
      :required="true"
      max="4"
      @sms-query="smsQuery"
      @keyup-enter="submit"
      :rule="[
        { required: true, message: `短信验证码不能为空`, trigger: `blur` },
        { pattern: pattern.positiveInt, message: `短信验证码不正确，4位数字`, trigger: `blur`},
        { min: 4, max: 4, message: `短信验证码不正确，4位数字`, trigger: `blur`}
      ]"
    />
    <div>
      <Button @click="$router.push(`/user/safe/list`)">
        取消
      </Button>
      <Button
        class="ml"
        type="primary"
        @click="submit">
        下一步
      </Button>
    </div>
  </div>
</template>

<script>
import Form2ItemInput from '@/components/form2-item-input';
import {captchaSms, updateMobile} from '@/service';
import pattern from '@/util/pattern';

export default {
  name: 'Index',
  components: {Form2ItemInput},
  data() {
    return {
      pattern,
      newIdentifier: '',
      imageCaptcha: '',
      smsCaptcha: '',
    };
  },
  methods: {
    smsQuery(next) {
      Promise.all([
        this.$refs['newIdentifier'].validate(),
        this.$refs['imageCaptcha'].validate(),
      ]).then(([valid1, valid2]) => {
        if (valid1 && valid2) {
          captchaSms({
            deviceId: this.$store.getters['system/deviceId'],
            mobile: this.newIdentifier,
            imageCaptcha: this.imageCaptcha,
          }).then((res) => {
            next(60);
          });
        }
      });
    },
    submit() {
      Promise.all([
        this.$refs['newIdentifier'].validate(),
        this.$refs['imageCaptcha'].validate(),
        this.$refs['smsCaptcha'].validate(),
      ]).then(([valid1, valid2, valid3]) => {
        if (valid1 && valid2 && valid3) {
          updateMobile({
            identifier: this.$store.state.user.userAuth.identifier,
            newIdentifier: this.newIdentifier,
            smsCaptcha: this.smsCaptcha,
          }).then(({resultDesc}) => {
            this.$emit('success');
          });
        }
      });
    },
  },
};
</script>
